import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { REQUEST, portalSuccess, portalFailure } from '../../actions/billing/portal';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* process() {
  try {
    const response = yield call(
      axios.post,
      `${config.API_URL}/billing/portal-session`,
      {},
      { headers: getLocalUser() },
    );
    const data = response.data?.data ?? response.data;
    yield put(portalSuccess(data));
    if (data && data.url && typeof window !== 'undefined') {
      window.location.assign(data.url);
    }
  } catch (error) {
    yield put(Error(error));
    yield put(portalFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
